import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import axios from 'axios';

import { pushResult, pushClickPayButton, sendAnalyticsOnPaymentSuccess } from 'utils/analytics/payments';

import { Status, PayOferta } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default class ApplePayButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
      isSuccess: false,
      error: null,
    };
  }

  componentDidMount() {
    const { ApplePaySession } = window;

    try {
      if (ApplePaySession && ApplePaySession.canMakePayments()) {
        setTimeout(() => this.setState({ isVisible: true }));
      }
    } catch (error) {
      console.warn(error.message);
    }
  }

  handleClick = () => {
    const { ApplePaySession } = window;
    const { paymentRequest, paymentData } = this.props;

    const session = new ApplePaySession(1, paymentRequest);

    pushClickPayButton('Apple Pay');

    session.onvalidatemerchant = (event) => {
      axios.post('/applepay/getsession', {
        url: event.validationURL,
        paymentType: 'MobileBalance',
      }).then(({ data }) => {
        session.completeMerchantValidation(data);
      }).catch((error) => {
        session.completeMerchantValidation({});
        this.setState({ error });
      });
    };

    session.onpaymentauthorized = (event) => {
      axios.post('/applepay/processpayment', {
        ...paymentData,
        paymentType: 'MobileBalance',
        applePayPaymentObject: event.payment,
      }).then(() => {
        session.completePayment(ApplePaySession.STATUS_SUCCESS);
        this.setState({ isSuccess: true });
        pushResult('apple', 'success');
        sendAnalyticsOnPaymentSuccess(this.props.paymentData.sum, 'apple');
      }).catch((error) => {
        session.completePayment(ApplePaySession.STATUS_FAILURE);
        this.setState({ error });
        pushResult('apple', 'error');
      });
    };

    session.begin();
  };

  render() {
    const { isVisible, isSuccess, error } = this.state;
    const { className, disabled } = this.props;

    if (!isVisible) return null;

    if (isSuccess) {
      return (
        <Status className={['success', 'compact', className]}>
          Счёт пополнен!
        </Status>
      );
    }

    if (error) {
      return (
        <Status className={['error', 'compact', className]}>
          Не получилось оплатить
        </Status>
      );
    }

    return (
      <div className={cx('component', className)}>
        <button
          className={cx('button')}
          type="button"
          disabled={disabled}
          onClick={this.handleClick}
        />
        <PayOferta type="appPay" />
      </div>
    );
  }
}

ApplePayButton.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  disabled: PropTypes.bool,
  paymentRequest: PropTypes.object,
  paymentData: PropTypes.object,
};
